import { useSEO, SITE } from "../lib/useSEO";

export const useLegalSEO = ({ title, description, path }) =>
    useSEO({
        title,
        description,
        path,
        ogImage: undefined,
        schemas: [
            {
                "@context": "https://schema.org",
                "@type": "WebPage",
                name: title,
                url: `${SITE.origin}${path}`,
                description,
                inLanguage: "en-US",
                isPartOf: {
                    "@type": "WebSite",
                    name: SITE.name,
                    url: SITE.origin,
                },
            },
        ],
    });
